<template>
    <div>
        <div class="mt-4 md:grid md:gap-6 md:grid-cols-3">
            <div class="md:col-span-1">
                <div class="sm:pl-0 sm:pr-5">
                    <h3 class="text-gray-800 text-base font-semibold leading-6">
                        Auto Accept
                    </h3>
                    <p class="mt-2 text-gray-500 text-sm">
                        Enable or disable auto accept orders
                    </p>
                </div>
            </div>
            <div class="mt-5 md:col-span-2 md:mt-0">
                <div class="shadow bg-white sm:rounded-md sm:overflow-hidden">
                    <div class="flex items-center mt-4 p-8">
                        <span
                            role="checkbox"
                            tabindex="0"
                            aria-checked="false"
                            class="group relative inline-flex flex-shrink-0 items-center justify-center w-10 h-5 focus:outline-none cursor-pointer"
                            @click="toggleAutoAccept"
                        >
                            <span
                                aria-hidden="true"
                                :class="{
                                    'bg-gray-200': !isAutoAccept,
                                    'bg-indigo-600': isAutoAccept
                                }"
                                class="absolute mx-auto w-9 h-4 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out"
                            ></span>
                            <span
                                aria-hidden="true"
                                :class="{
                                    'translate-x-0': !isAutoAccept,
                                    'translate-x-5': isAutoAccept
                                }"
                                class="absolute left-0 inline-block w-5 h-5 bg-white border group-focus:border-blue-300 border-gray-200 rounded-full shadow group-focus:shadow-outline transform translate-x-0 transition-transform duration-200 ease-in-out"
                            ></span>
                        </span>
                        <span
                            class="pl-3 text-gray-700 text-sm font-medium leading-5"
                        >
                            Auto Accept
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-4 md:grid md:gap-6 md:grid-cols-3">
            <div class="md:col-span-1">
                <div class="sm:pl-0 sm:pr-5">
                    <h3 class="text-gray-800 text-base font-semibold leading-6">
                        Auto Ready
                    </h3>
                    <p class="mt-2 text-gray-500 text-sm">
                        Automatically mark orders as ready based on fulfillment type
                    </p>
                </div>
            </div>
            <div class="mt-5 md:col-span-2 md:mt-0">
                <div class="shadow bg-white sm:rounded-md sm:overflow-hidden">
                    <div class="space-y-6 px-4 py-5 sm:p-6">
                        <fieldset>
                            <legend class="text-base font-medium leading-6 text-gray-900">
                                Auto Ready for fulfillment types
                            </legend>
                            <div class="mt-2">
                                <base-checkbox
                                    v-model="autoReadyDelivery"
                                    id="autoReadyDelivery"
                                    label="Delivery"
                                    caption="Automatically mark delivery orders as ready"
                                />
                            </div>
                            <div class="mt-2">
                                <base-checkbox
                                    v-model="autoReadyPickup"
                                    id="autoReadyPickup"
                                    label="Pickup"
                                    caption="Automatically mark pickup orders as ready"
                                />
                            </div>
                            <div class="mt-2" v-if="acceptsInStore">
                                <base-checkbox
                                    v-model="autoReadyInStore"
                                    id="autoReadyInStore"
                                    label="In-Store"
                                    caption="Automatically mark in-store orders as ready"
                                />
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FulfillmentMethodsEnum } from '@/enums';

export default {
    name: 'AutoAcceptSettings',
    props: {
        autoAccept: {
            type: Boolean,
            required: true
        },
        autoReadyEnabled: {
            type: Array,
            default: () => []
        },
        acceptsInStore: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isAutoAccept(value) {
            this.$emit('change-operation-property', 'autoAccept', value);
        },
        autoReadyEnabledArray: {
            handler(value) {
                this.$emit('change-operation-property', 'autoReadyEnabled', value);
            },
            deep: true
        }
    },
    data() {
        return {
            isAutoAccept: this.autoAccept,
            autoReadyDelivery: this.autoReadyEnabled.includes(FulfillmentMethodsEnum.DELIVERY),
            autoReadyPickup: this.autoReadyEnabled.includes(FulfillmentMethodsEnum.PICKUP),
            autoReadyInStore: this.autoReadyEnabled.includes(FulfillmentMethodsEnum.IN_STORE)
        };
    },
    computed: {
        autoReadyEnabledArray() {
            const enabled = [];
            if (this.autoReadyDelivery) enabled.push(FulfillmentMethodsEnum.DELIVERY);
            if (this.autoReadyPickup) enabled.push(FulfillmentMethodsEnum.PICKUP);
            if (this.autoReadyInStore) enabled.push(FulfillmentMethodsEnum.IN_STORE);
            return enabled;
        }
    },
    methods: {
        toggleAutoAccept() {
            this.isAutoAccept = !this.isAutoAccept;
        }
    }
};
</script>
